import { object } from 'yup';

import { createValidator } from '@src/validation';
import { textValidator } from '@src/validation/textValidator';
import { controlsStore } from '@stores/dictionaryStores/controlsStore/controlsStore';

const validateSchema = object().shape({
  repGroupCode: textValidator({ fieldName: 'repGroupCode' }),
  ctrlCode: textValidator({ fieldName: 'ctrlCode' }).test(
    'ctrlCode',
    'Технический код контроля должен быть уникальным',
    (value, { parent: { id } }) => {
      const { controls } = controlsStore;
      return !controls.some((control) => control.ctrlCode === value && control.id !== id);
    },
  ),
  ctrlExt: textValidator({ fieldName: 'ctrlExt' }),
  ctrlName: textValidator({ fieldName: 'ctrlName' }),
});

export const validate = createValidator(validateSchema);
